__turbopack_context__.v({
  "pageTabs": "_1Urxxa_pageTabs",
  "tabLink": "_1Urxxa_tabLink",
  "tabsContainer": "_1Urxxa_tabsContainer",
  "tabsContainerVertical": "_1Urxxa_tabsContainerVertical",
  "tabsContainerWrap": "_1Urxxa_tabsContainerWrap",
});
